import { render } from "../upload_consent/upload_consent.html?vue&type=template&id=b67c2c6a&external"
import script from "../upload_consent/upload_consent.js?vue&type=script&lang=js&external"
export * from "../upload_consent/upload_consent.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__